import React from "react";
import { Button, FormFieldSet, useFormHandler } from "../../../../components";
import { BillRateType } from "../../../../assets/data/enumData";

const FillDetailsClient = ({
  formData,
  errors,
  handleChange,
  isFetchedEntity,
  onboardingId
}) => {
  return (
    <div>
      <div className="m-4">
        {!onboardingId && <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
          <FormFieldSet
            type="clientsSortedOnboarding"
            title="Select Client"
            placeholder="Select Client"
            value={formData.clientName}
            onChange={(value) => handleChange("clientName", value)}
            showSearch
            error={errors.clientName}
          />
        </div>}

        {/* Client Business Details */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          <FormFieldSet
            // type="select"
            title="Business Name"
            placeholder="Enter Business Name"
            value={formData.clientBusinessName}
            onChange={(value) => handleChange("clientBusinessName", value)}
            error={errors.clientBusinessName}
            disabled={true}
            // options={[
            //   { label: "prudhvi", value: 1 },
            //   { label: "pushpak", value: 2 },
            //   { label: "Sravan", value: 3 },
            //   { label: "sudhakar", value: 4 },
            // ]}
          />
          <FormFieldSet
            title="DBA Business Name"
            placeholder="Enter DBA Business Name"
            value={formData.clientDbaBusinessName}
            onChange={(value) => handleChange("clientDbaBusinessName", value)}
            error={errors.clientDbaBusinessName}
            disabled={true}
          />
          <FormFieldSet
            title="FEIN Number"
            placeholder="Enter FEIN Number"
            value={formData.clientFeinNumber}
            onChange={(value) => handleChange("clientFeinNumber", value)}
            error={errors.clientFeinNumber}
            disabled={true}
          />
          <div className="col-span-2 lg:col-span-3">
            <FormFieldSet
              type="text"
              title="Full Address"
              placeholder="Enter Full Address"
              value={formData.clientFullAddress}
              onChange={(value) => handleChange("clientFullAddress", value)}
              error={errors.clientFullAddress}
            disabled={true}
            />
          </div>

          <FormFieldSet
            type="countriesUsAndCanada"
            title={"Country"}
            placeholder="Select Country"
            value={formData.clientCountry}
            onChange={(value) => handleChange("clientCountry", value)}
            disabled={true}
          />
          <FormFieldSet
            showSearch
            type="states"
            title={"State"}
            keyname={"states"}
            placeholder="Select State"
            value={formData.clientState}
            error={errors.clientState}
            onChange={(value) => handleChange("clientState", value)}
            parentValue={{
              country: formData?.clientCountry?.value ?? formData.clientCountry,
            }}
            disabled={true}
          />
          <FormFieldSet
            type="cities"
            showSearch
            keyname={"cities"}
            title={"City"}
            placeholder="Select City"
            value={formData.clientCity}
            error={errors.clientCity}
            onChange={(value) => handleChange("clientCity", value)}
            parentValue={{
              country: formData?.clientCountry?.value ?? formData?.clientCountry,
              state: formData?.clientState?.value || formData?.clientState,
            }}
            disabled={true}

            // parentId={countryId}
          />
          <FormFieldSet
            type="text"
            title="Zip Code"
            placeholder="Enter Zip Code"
            value={formData.clientZipCode}
            error={errors.clientZipCode}
            onChange={(value) => handleChange("clientZipCode", value)}
            disabled={true}
          />
        </div>

        {/* Placement Details */}
        <div className="mt-5">
          <span className="text-xl">Placement</span>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
            <FormFieldSet
              title="Vendor"
              placeholder="Enter Vendor Name"
              value={formData.clientVendor}
              error={errors.clientVendor}
              onChange={(value) => handleChange("clientVendor", value)}
              disabled={true}
            />
            <FormFieldSet
              type="select"
              title="Placement Type"
              placeholder="Select Placement"
              value={formData.clientSelectPlacementType}
              error={errors.clientSelectPlacementType}
              onChange={(value) =>
                handleChange("clientSelectPlacementType", value)
              }
              options={[
                { label: "Contract", value: 1 },
                { label: "Fulltime", value: 2 },
              ]}
            />
            <FormFieldSet
              title="Job Title"
              placeholder="Enter Job Title"
              value={formData.clientJobTitle}
              error={errors.clientJobTitle}
              onChange={(value) => handleChange("clientJobTitle", value)}
            />
            <div className="grid grid-cols-2 gap-4">
              <FormFieldSet
                type="datepicker"
                title="Start Date"
                placeholder="Start Date"
                value={formData.clientStartDate}
                error={errors.clientStartDate}
                onChange={(value) => handleChange("clientStartDate", value)}
                showDropdown={false}
              />
              <FormFieldSet
                type="datepicker"
                title="End Date"
                placeholder="End Date"
                value={formData.clientEndDate}
                error={errors.clientEndDate}
                onChange={(value) => handleChange("clientEndDate", value)}
                showDropdown={false}
              />
            </div>
            <FormFieldSet
              title="Email"
              placeholder="Enter Email"
              value={formData.clientEmail}
              error={errors.clientEmail}
              onChange={(value) => handleChange("clientEmail", value)}
            />
            <FormFieldSet
              title="Candidate Name"
              placeholder="Enter Candidate Name"
              value={formData.clientCandidateName}
              error={errors.clientCandidateName}
              onChange={(value) => handleChange("clientCandidateName", value)}
            />
            <div className="grid grid-cols-2 gap-4">
              <FormFieldSet
                title="Bill Rate"
                placeholder="Enter Bill Rate"
                value={formData.clientBillRate}
                error={errors.clientBillRate}
                onChange={(value) => handleChange("clientBillRate", value)}
              />
              <FormFieldSet
                title=""
                type="select"
                placeholder="Hourly"
                options={BillRateType}
                value={formData.clientBillRateHourly}
                error={errors.clientBillRateHourly}
                onChange={(value) =>
                  handleChange("clientBillRateHourly", value)
                }
              />
            </div>
            <FormFieldSet
              type="select"
              title="Tax Terms"
              placeholder="Enter Tax Terms"
              error={errors.clientTaxTerms}
              options={[
                { label: "oneTerm", value: 1 },
                { label: "Twoterm", value: 2 },
              ]}
              value={formData.clientTaxTerms}
              onChange={(value) => handleChange("clientTaxTerms", value)}
            />
            <FormFieldSet
              title="OT Bill Rate"
              placeholder="OT Bill Rate /hr"
              value={formData.clientOtBillRate}
              error={errors.clientOtBillRate}
              onChange={(value) => handleChange("clientOtBillRate", value)}
            />
            {/* <FormFieldSet
              title="DT Bill Rate"
              placeholder="DT Bill Rate /hr"
              value={formData.clientDtBillRate}
              onChange={(value) => handleChange("clientDtBillRate", value)}
            />
            <div className="grid grid-cols-2 gap-4">
              <FormFieldSet
                title="Pay Rate"
                placeholder="Pay Rate /hr"
                value={formData.clientPayRate}
                onChange={(value) => handleChange("clientPayRate", value)}
              />
              <FormFieldSet
                title=""
                placeholder="Hourly"
                // options={[
                //   { label: "12/hr", value: 12 },
                //   { label: "24/hr", value: 24 },
                // ]}
                value={formData.clientPayRateHourly}
                onChange={(value) => handleChange("clientPayRateHourly", value)}
              />
            </div>
            <FormFieldSet
              title="OT Pay Rate"
              placeholder="OT Pay Rate /hr"
              value={formData.clientOtPayRate}
              onChange={(value) => handleChange("clientOtPayRate", value)}
            /> */}
          </div>
        </div>

        {/* Contacts */}
        <div className="mt-5">
          <span className="text-xl">Contacts</span>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
            {/* <FormFieldSet
              title="Primary Contact"
              placeholder="Enter Contact Name"
              value={formData.clientPrimaryContact}
              onChange={(value) => handleChange("clientPrimaryContact", value)}
            /> */}
            <FormFieldSet
              title="Primary Contact Name"
              placeholder="Enter Contact Name"
              error={errors.clientPrimaryContactNumber}
              value={formData.clientPrimaryContactNumber}
              onChange={(value) =>
                handleChange("clientPrimaryContactNumber", value)
              }
              disabled={true}
            />
            <FormFieldSet
              title="Job Title"
              placeholder="Enter Job Title"
              value={formData.clientTitle}
              error={errors.clientTitle}
              onChange={(value) => handleChange("clientTitle", value)}
              disabled={true}
            />
            <FormFieldSet
              title="Email"
              placeholder="Enter Email"
              value={formData.clientContactEmail}
              error={errors.clientContactEmail}
              onChange={(value) => handleChange("clientContactEmail", value)}
              disabled={true}
            />
            <FormFieldSet
              title="Phone Number"
              placeholder="Enter Phone Number"
              value={formData.clientContact}
              error={errors.clientContact}
              onChange={(value) => handleChange("clientContact", value)}
              disabled={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FillDetailsClient;
